/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Link { 
    id: string;
    programId: string;
    label: string;
    alias: string;
    url: string;
    visibility: Link.VisibilityEnum;
    createdAt: string;
    updatedAt: string;
}
export namespace Link {
    export const VisibilityEnum = {
        _0: '0',
        _1: '1'
    } as const;
    export type VisibilityEnum = typeof VisibilityEnum[keyof typeof VisibilityEnum];
}


